import useElysiaStore from '@/app/elysia-store';

const AppAgentHeading = () => {
  const name = useElysiaStore((state) => state.name);
  const uploadedIcon = useElysiaStore((state) => state.uploadedIcon);
  return (
    <div className="d-flex">
      {uploadedIcon?.iconId && uploadedIcon?.iconUrl && (
        <div className="app-heading-icon">
          <img src={uploadedIcon?.iconUrl} alt="icon" className="icon" />
        </div>
      )}
      <div>
        <h4 className="fw-semibold">{name}</h4>
      </div>
    </div>
  );
};

export default AppAgentHeading;
